import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';


import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { Link, useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../utils/AuthContext';
import AlertDialog from './AlertDialog';
import { useState } from 'react';
import { logout } from '../services/AuthService';







export default function MenuContent({ sx, currentPage, setOpen }) {
  const navigate = useNavigate();
  const { auth, setAuth } = useContext(AuthContext);

  const mainListItems = [
    { text: 'Overview', icon: <DashboardOutlinedIcon />, url: '/overview', pageId: 'overview' },
    { text: 'Clients', icon: <PeopleAltOutlinedIcon />, url: '/clients', pageId: 'clients' },
    { text: 'Referrals', icon: <PersonAddAltOutlinedIcon />, url: '/referrals', pageId: 'referrals' },
    { text: 'Users', icon: <ManageAccountsOutlinedIcon />, url: '/users', pageId: 'users' },
  ].filter(item => {
    if (auth.user.user_type === 'Agent' && item.pageId === 'users') {
      return false; // Remove Users page for regular users
    }
    if (auth.user.user_type === 'Admin' && item.pageId === 'overview') {
      return false; // Remove Overview page for admins
    }
    return true; // Keep other pages
  });

  const secondaryListItems = [
    { text: 'Profile Settings', icon: <SettingsOutlinedIcon />, url: '/profile', pageId: 'profile', type: 'link' },
    { text: 'Logout', icon: <LogoutOutlinedIcon />, url: '/login', pageId: 'logout', type: 'action' },
  ];

  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);

  function handleSecondaryListItemClicked(pageId) {
    
    if (pageId === 'logout') {
      // if (setOpen) {
      //   setOpen(false);
      // }
      

      setOpenLogoutDialog(true);
    }
  }

  function handleLogout() {
    localStorage.removeItem('agent-connect-api-token');
    localStorage.removeItem('agent-connect-current-user');


    setAuth({
      token: null,
      user: null
    });

    logout({ token: auth.token });

    navigate('/login');
  }



  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between', ...sx }}>
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton LinkComponent={Link} to={item.url} selected={currentPage === item.pageId} sx={{

              '&.Mui-selected': {
                backgroundColor: '#624DE3',
                color: '#fff', // Custom color when selected
                '&:hover': {
                  backgroundColor: '#624DE3', // Hover effect when selected
                },
                borderRadius: 1
              },
            }}>
              <ListItemIcon sx={{ color: currentPage === item.pageId ? '#fff' : '#334155' }}>{item.icon}</ListItemIcon>
              <ListItemText sx={{ color: currentPage === item.pageId ? '#fff' : '#334155' }} primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      <List dense>
        {secondaryListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              LinkComponent={item.type === 'link' ? Link : null}
              to={item.type === 'link' ? item.url : null}
              onClick={item.type === 'action' ? () => {
                // closeDrawer();
                handleSecondaryListItemClicked(item.pageId)
              } : null}
              selected={currentPage === item.pageId}
              sx={{

                '&.Mui-selected': {
                  backgroundColor: '#624DE3',
                  color: '#fff', // Custom color when selected
                  '&:hover': {
                    backgroundColor: '#624DE3', // Hover effect when selected
                  },
                  borderRadius: 1
                },
              }}>
              <ListItemIcon sx={{ color: currentPage === item.pageId ? '#fff' : '#334155' }}>{item.icon}</ListItemIcon>
              <ListItemText sx={{ color: currentPage === item.pageId ? '#fff' : '#334155' }} primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      <AlertDialog
        open={openLogoutDialog}
        setOpen={setOpenLogoutDialog}
        title="Are you sure you want to log out?"
        content="Please confirm by clicking continue."
        positiveButtonLabel="Continue"
        negativeButtonLabel="Cancel"
        callback={() => {
          handleLogout();
        }}
      />
    </Stack>
  );
}
